import AddPeopleExplainer from './addPeopleExplainer'

export default AddPeopleExplainer